import styled from 'styled-components'

export const TopBar = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 1rem 2rem;
  margin-bottom: 2em;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`
